package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_category_domain_di_AddEditCategoryUseCaseModule : Module get() = module {
	single() { _ -> com.essntl.features.category.domain.usecase.AddEditCategoryUseCase(categoryRepository=get()) } 
}
public val com.essntl.features.category.domain.di.AddEditCategoryUseCaseModule.module : org.koin.core.module.Module get() = com_essntl_features_category_domain_di_AddEditCategoryUseCaseModule
